export function resolveRequiresComponents(to) {
  const promises = [];
  const route = to.matched[to.matched.length - 1];
  const requiresComponents = route && route.meta && route.meta.requiresComponents;
  if (!requiresComponents) return promises;
  requiresComponents.forEach(comp => promises.push(comp()));
  return promises;
}
